const cards = {
    'A20011' :{"id":"A20011","theme":"马上有福","content":"福启新程马上到，平安喜乐，事事顺心无烦忧~"},
    'B20011':{"id":"B20011","theme":"马上有钱","content":"马上有钱来，财运滚滚，新岁安康享荣华～"},
    'C20011' :{"id":"C20011","theme":"大吉大利","content":"新年自带好运 BUFF，大吉大利全开挂，巅峰夺冠笑哈哈！"},
    'D20011' :{"id":"D20011","theme":"阖家幸福","content":"阖家欢乐笑语满堂，平安喜乐，团圆安康岁岁欢愉~"},
    'E20011' :{"id":"E20011","theme":"上号集结","content":"新年开黑组队冲，友情不散，一路躺赢不翻车！"},
    'F20011' :{"id":"F20011","theme":"岁岁安康","content":"岁岁安康，福禄常在，日子甜暖步步高~"},
    'G20011' :{"id":"G20011","theme":"欧气爆棚","content":"新年欧气爆棚，好运加持，锦鲤附体事事顺～"},
    'H20011' :{"id":"H20011","theme":"红包暴击","content":"红包暴击启新岁，惊喜不断，平安喜乐财福双收！"},
    'I20011' :{"id":"I20011","theme":"旗开得胜","content":"新年旗开得胜，万事顺遂，鸿运当头福满盈～"},
    'J20011' :{"id":"J20011","theme":"百战百胜","content":"百战百胜迎新年，巅峰相见，所向披靡，一统三国！"}
}

export default cards;